/* global google */
import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import * as UIActions from '../../actions/ui';
import * as BookingActions from '../../actions/bookingAction';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import copy from 'copy-to-clipboard';
import { compose, withProps, lifecycle } from "recompose"
import { dropoffIcon, pickupIcon, allStarCarIcon, upArrow, downArrow, fromDestination } from "../../resources/images";
import { withScriptjs, withGoogleMap, GoogleMap, Marker, Polyline } from "react-google-maps";
import { AppConfig } from '../../configs'
import moment from 'moment';
import packageJson from '../../../package.json'

const { googleAPIKey } = AppConfig;

const MyMapComponent = compose(
    withProps({
        googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${googleAPIKey}&v=3.exp&libraries=geometry,drawing,places`,
        loadingElement: <div style={{ height: `100%`, width: `100%` }} />,
        containerElement: <div style={{ height: `100%`, width: `100%` }} />,
        mapElement: <div style={{ height: `100%`, width: `100%` }} />,
    }),
    withScriptjs,
    withGoogleMap,
    lifecycle({
        componentDidMount() {
            this.renderRoute();
        },
        renderRoute() {
            const pickupImg = new google.maps.MarkerImage(
                pickupIcon,
                null,
                null,
                null,
                new google.maps.Size(30, 40));
            const dropoffImg = new google.maps.MarkerImage(
                dropoffIcon,
                null,
                null,
                null,
                new google.maps.Size(30, 40));
            const taxiIcon = new google.maps.MarkerImage(
                allStarCarIcon,
                null,
                null,
                null,
                new google.maps.Size(70, 70));
            this.setState({
                route1: this.props.route,
                pickupImg: pickupImg,
                dropoffImg: dropoffImg,
                taxiIcon: taxiIcon
            });

        }
    })
)(props =>
    <GoogleMap
        zoom={props.zoom}
        center={props.center}
        defaultOptions={{
            mapTypeControl: false,
            fullscreenControl: false,
            streetViewControl: true,
            zoomControl: false
        }}
    >
        {props.pickup &&
            <Marker icon={props.pickupImg} position={{ lat: props.pickup.lat, lng: props.pickup.lng }}
                onClick={props.onMarkerClick} />
        }
        {props.dropoff &&
            <Marker icon={props.dropoffImg} position={{ lat: props.dropoff.lat, lng: props.dropoff.lng }}
                onClick={props.onMarkerClick} />
        }
        {props.current &&
            <Marker icon={props.taxiIcon} position={{ lat: props.current.latitude, lng: props.current.longitude }}
                onClick={props.onMarkerClick} />
        }
        {props.route && props.route.map((point, idx) =>
            <Polyline
                key={idx}
                geodesic={false}
                path={point}
                options={{
                    strokeColor: '#212322',
                    strokeOpacity: 1,
                    strokeWeight: 5,
                    icons: [{
                        offset: '0',
                        repeat: '10px'
                    }],
                }}
            />
        )}
    </GoogleMap>
);

class PublicTracking extends Component {

    constructor(props) {
        super(props);

        this.state = {
            center: {
                lat: 3.086489,
                lng: 101.616413
            },
            zoom: 9,
            route: [],
            bookingInfo: {},
            loading: true,
            index: 0,
            from: {},
            toggle: false
        }

    }

    componentDidMount = async () => {
        const { addError, match } = this.props;
        let id = match.params.id
        let token = match.params.token

        if (id && token) {
            this.getBookingDetail(id, token)
            this.startBookingTimer = setInterval(() => this.getBookingDetail(id, token), 10000);
        } else if (id && !token) {
            addError('This URL is generated using an older version of MOVE app. Please update your app and get a new URL.');
        }

    }

    componentWillUnmount = () => {
        clearInterval(this.startBookingTimer)
    }

    getBookingDetail = async (id, token) => {
        try {
            const isDesktop = window.innerWidth > 769
            const res = await this.props.getBookingDetail(id, token)

            let center = this.center
            let zoom = isDesktop ? 12 : 9


            if (res.data) {
                if (!['On_The_Way', 'Arrived', 'On_Board', 'Finalize_Total_Fare'].includes(res.data.status)) {
                    this.props.history.push('/redirect/inactive')
                    return
                }

                if (res.data.loc_info) {
                    center = {
                        lat: res.data.loc_info.latitude,
                        lng: res.data.loc_info.longitude
                    }
                    zoom = isDesktop ? 18 : 16

                }


                const route = res.data.waypoints?.length ?
                    res.data.waypoints.map(item => ({ lat: Number(item.latitude.toFixed(5)), lng: Number(item.longitude.toFixed(5)) })) :
                    []
                this.setState({
                    bookingStatus: res.data.status,
                    bookingInfo: res.data,
                    center,
                    zoom,
                    route: [route],
                    from: res.data.from
                })
            } else {
                this.props.history.push('/redirect/error')
            }

        } catch (err) {
            if (err.message === "Booking is not active") {
                this.props.history.push('/redirect/inactive')
            } else {
                this.props.history.push('/redirect/error')
            }

        }
        this.setState({ loading: false })
    }

    onCopy = (text) => {
        copy(text);
        this.props.showSuccess(`${text} has been copied to clipboard`)
    }

    getStatusFormat = () => {
        const status = this.state.bookingStatus

        switch (status) {
            case 'Pending_Acceptance':
                return (
                    <div className="dcStatusBar">
                        <FormattedMessage
                            defaultMessage='Pending Acceptance'
                            id='BookingDetail.js.Pending_Acceptance'
                        />
                    </div>
                )
            case 'Confirmed':
                return (
                    <div className="dcStatusBar">
                        <FormattedMessage
                            defaultMessage='Confirmed'
                            id='BookingDetail.js.Confirmed'
                        />
                    </div>
                )
            case 'On_The_Way':
                return (
                    <div className="dcStatusBar">
                        <FormattedMessage
                            defaultMessage='On the way'
                            id='BookingDetail.js.On the way'
                        />
                    </div>
                )
            case 'Arrived':
                return (
                    <div className="dcStatusBar">
                        <FormattedMessage
                            defaultMessage='Arrived'
                            id='BookingDetail.js.Arrived'
                        />
                    </div>
                )
            case 'On_Board':
                return (
                    <div className="dcStatusBar">
                        <FormattedMessage
                            defaultMessage='On Board'
                            id='BookingDetail.js.On Board'
                        />
                    </div>
                )
            case 'Finalize_Total_Fare':
                return (
                    <div className="dcStatusBar">
                        <FormattedMessage
                            defaultMessage='Finalizing Fare'
                            id='BookingDetail.js.Finalizing Fare'
                        />
                    </div>
                )
            case 'Completed':
                return (
                    <div className="dcStatusBar">
                        <FormattedMessage
                            defaultMessage='Completed'
                            id='BookingDetail.js.Completed'
                        />
                    </div>
                )
            default:
                return null
        }
    }

    onToggleCont() {
        this.setState(prevState => ({ toggle: !prevState.toggle }))
    }

    render() {
        const { center, route, bookingInfo, loading, zoom, from = {}, toggle } = this.state;
        const { code, booking_at, destination = {}, driver_info, vehicle_info, loc_info = {} } = bookingInfo || {}
        const { userId, fullName, phoneCountryCode, phoneNo, avatars } = driver_info || {}
        const { registrationNo, manufacturer, model, color, frontPhoto, backPhoto } = vehicle_info || {}
        const mainLogo = `${AppConfig.bucketUrl}/Logos/app-logo-ride.png`;
        const { version } = packageJson;

        return (
            <div className="publicTracking">
                <div className="desktopMap">
                    <MyMapComponent pickup={from && from.coords}
                        dropoff={destination && destination.coords}
                        center={center}
                        route={route}
                        current={loc_info}
                        zoom={zoom}
                    />
                </div>
                <div className="dcHeader">
                    <div className="logoCont">
                        <img src={mainLogo} alt="" className="dcLogo" onClick={() => window.open("https://airasia.com/#/")} />
                        <div className="fDisplay">v{version}</div>
                    </div>
                </div>
                <div className="infoCont">
                    <div className="mapCont">
                        <div className="mobileMap">
                            <MyMapComponent pickup={from && from.coords}
                                dropoff={destination && destination.coords}
                                center={center}
                                route={route}
                                current={loc_info}
                                zoom={zoom}
                            />
                        </div>

                    </div>
                    <div className="addressCont">
                        <div className="expandCont" onClick={() => this.onToggleCont()}>
                            <img src={upArrow} alt="" className="dcImg" />
                        </div>
                    </div>
                    <div className="bookingInfoCont">
                        <div className="dcCol">
                            {!loading &&
                                <div className="dcBookingTitle">{code}</div>
                            }
                            {!!booking_at &&
                                <div className="dcBookingDate">{moment(booking_at).format('DD MMM YYYY, hh:mm A')}</div>
                            }
                        </div>
                        {this.getStatusFormat()}

                    </div>
                    <div className="bookingInfoCont">
                        <div className="itemCont">
                            <div className="fCaption">From</div>
                            <div className="fTitle">{from.name}</div>
                        </div>
                        <img src={fromDestination} alt="" className="dcIcon" />
                        <div className="itemCont">
                            <div className="fCaption">To</div>
                            <div className="fTitle">{destination.name}</div>
                        </div>
                    </div>
                    <div className="driverCont">
                        <div className="driverInfoCont driverInfo">
                            <div className="fDisplay">Driver Info</div>
                            <div className="dcRow">
                                {avatars && avatars.length > 0 &&
                                    <img src={avatars[avatars.length - 1].url} alt="" className="dcImg" />
                                }
                                <div className="dataCont">
                                    <div className="fTitle">{fullName ? fullName : '-'}</div>
                                    <div className="fCaption">{userId ? userId : '-'}</div>
                                    <div className="dcRow">
                                        <div className="fCaption" style={{ color: '#4B4FA6' }} onClick={() => this.onCopy(`${phoneCountryCode}${phoneNo}`)} >{phoneCountryCode}{phoneNo}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="driverInfoCont vehicleInfo">
                            <div className="dcRow">
                                <div className="dataCont">
                                    <div className="fTitle">{manufacturer} {model}</div>
                                    <div className="fCaption">{registrationNo}</div>
                                    <div className="fCaption">{color}</div>
                                </div>
                                {frontPhoto &&
                                    <img src={frontPhoto.url} alt="" className="dcImage" />
                                }
                                {backPhoto &&
                                    <img src={backPhoto.url} alt="" className="dcImage backPhoto" />
                                }
                            </div>
                        </div>
                    </div>
                </div>
                {!!toggle &&
                    <div className="dcBackdrop animated fadeIn">
                        <div className="bookingDetailCont animated slideInUp">
                            <div className="collapseCont" onClick={() => this.onToggleCont()}>
                                <img src={downArrow} alt="" className="dcImg" />
                            </div>
                            <div className="bodyBox">
                                <div className="bookingItemRow">
                                    <div className="bookingCol">
                                        <div className="bookingTitle">{code}</div>
                                        <div className="bookingCaption">{moment(booking_at).format('DD MMM YYYY, hh:mm A')}</div>
                                    </div>
                                    {this.getStatusFormat()}
                                </div>
                                <div className="bookingitemCont">
                                    <div className="bookingTitle">From</div>
                                    <div className="bookingCaption">{from.name}</div>
                                    <div className="bookingCaption address">{from.address}</div>
                                </div>
                                <div className="bookingitemCont">
                                    <div className="bookingTitle">To</div>
                                    <div className="bookingCaption">{destination.name}</div>
                                    <div className="bookingCaption address">{destination.address}</div>
                                </div>
                                <div className="bookingitemCont noBorder">
                                    <div className="bookingCaption">Driver Info</div>
                                    <div className="dcRow">
                                        {avatars && avatars.length > 0 &&
                                            <img src={avatars[avatars.length - 1].url} alt="" className="dcImg" />
                                        }
                                        <div className="dataCont">
                                            <div className="fTitle">{fullName ? fullName : '-'}</div>
                                            <div className="fCaption">{userId ? userId : '-'}</div>
                                            <div className="fCaption" style={{ color: '#4B4FA6' }} onClick={() => this.onCopy(`${phoneCountryCode}${phoneNo}`)} >{phoneCountryCode}{phoneNo}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="bookingitemCont">
                                    <div className="dcRow vehicleInfo">
                                        <div className="dataCont">
                                            <div className="fTitle">{manufacturer} {model}</div>
                                            <div className="fCaption">{registrationNo}</div>
                                            <div className="fCaption">{color}</div>
                                        </div>
                                        {frontPhoto &&
                                            <img src={frontPhoto.url} alt="" className="dcImage" />
                                        }
                                        {backPhoto &&
                                            <img src={backPhoto.url} alt="" className="dcImage backPhoto" />
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = ({ UserStore }) => ({
    UserStore,
});

const mapDispatchToProps = (dispatch) => ({
    showSuccess: (message) => dispatch(UIActions.showSuccess(message)),
    getBookingDetail: (id, token) => dispatch(BookingActions.getBookingDetail(id, token)),
    addError: (msg) => dispatch(UIActions.addError(msg)),
});

export default withRouter(injectIntl(connect(mapStateToProps, mapDispatchToProps)(PublicTracking)));
